export enum DataTestId {
    CurrencySelectDialogSelectionCard = 'currency-select-dialog-selection-card',
}

export interface Currency {
    code: string;
    symbol: string;
    description: string | null;
}
